export class InvCoutingEntity{
    id:number;
    coutingType:string;
    palletId:number;
    cardId:number;
    card:string;
    sampling:number;
    total:number;
    status:string;
    type:string;
    quantity:number;
    creationDate:string;
    startDate:string;
    endDate:string;
    creationUserId:number;
    creationUser:string;
    assistant:string;
    cyclicId:number;
    cyclic:string;
    pallet:string;
    palletType:string;
    customer:string;
    sapCode:string;
    location:string;

    constructor(){}
}